import { Button } from '@/components/Common';
import { Modal } from '@/components/Layout';
import React from 'react';
import { useSettingUpTests } from './SettingUpTest.hook';

const QuestionDeletionModal = () => {
  const {
    isDeleteQuestionPending,
    isOpenQuestionDeleteModal,
    setIsOpenQuestionDeleteModal,
    handleDeleteQuestion,
  } = useSettingUpTests();

  return (
    <Modal
      isOpen={isOpenQuestionDeleteModal}
      onClose={() => setIsOpenQuestionDeleteModal(false)}
      modalStyle="bg-[#2A2A2A] min-w-[23.4375rem]"
      headerStyle="bg-[#2A2A2A]"
    >
      <div className="flex flex-col gap-1">
        <h3 className="text-white text-xl font-bold text-center mb-2">
          Supprimer la question
        </h3>
        <p className="text-center text-gray-400 mx-auto my-0">
          Êtes-vous sûr de vouloir supprimer ?{' '}
        </p>
        <div className="flex justify-between items-center gap-6 mt-4">
          <Button
            onClick={() => setIsOpenQuestionDeleteModal(false)}
            title="Annuler"
            className="!bg-completed hover:!outline-completed hover:!text-completed
              hover:!bg-hoverColor text-white !px-16"
          />
          <Button
            className="!px-16"
            title={
              isDeleteQuestionPending ? 'Suppression en cours...' : 'Supprimer'
            }
            onClick={handleDeleteQuestion}
          />
        </div>
      </div>
    </Modal>
  );
};

export default QuestionDeletionModal;
